<div class="container mt-5">
    <div class="row mb-5">
        <div class="col mb-5">
            <div class="card mb-5">
                <div class="card-header bg-primary text-white">
                    <div class="row align-items-center">
                        <p class="h3 m-0 col">Manage metadata</p>
                        <div class="col text-right">
                            <button class="btn btn-outline-light btn-sm ml-2" (click)="toggleDisabled()">
                                <span *ngIf="!showDisabled">Show disabled metadata</span>
                                <span *ngIf="showDisabled">Hide disabled metadata</span>
                                <i class="fa fa-filter ml-2"></i>
                            </button>
                            <button class="btn btn-outline-light btn-sm ml-2" (click)="createMetadata()">
                                Create metadata <i class="ml-2 fa fa-plus"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <table class="table">
                        <colgroup>
                            <col class="col-auto">
                            <col class="col-auto">
                            <col class="col-auto">
                            <col class="col-auto">
                        </colgroup>
                        <thead>
                            <tr>
                                <th>Type</th>
                                <th>Name</th>
                                <th>URL</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let metadata of metadataList; let i = index">
                                <ng-container *ngIf="showDisabled || (!showDisabled && !metadata.disabled)">
                                    <td>
                                        <span *ngIf="metadata.metadataType == metadataType.Source">Source</span>
                                        <span *ngIf="metadata.metadataType != metadataType.Source">{{getMetadataTypeName(metadata.metadataType)}}</span>
                                    </td>
                                    <td><span [ngClass]="{'text-muted strikethrough': metadata.disabled}"><strong>{{metadata.name}}</strong></span></td>
                                    <td class="breakwords-md">
                                        <a *ngIf="metadata.url" href="{{metadata.url}}" target="_blank" role="button">{{metadata.url}}</a>
                                        <span *ngIf="!metadata.url">-</span>
                                    </td>
                                    <td class="text-right">
                                        <i class="fa fa-pencil btn btn-primary-invert" (click)="editMetadata(metadata)"></i>
                                    </td>
                                </ng-container>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>


